import styled from 'styled-components';
import appTheme from '../../theme/appTheme';

const StyledOcPopoverContent = styled.div`
  padding: ${appTheme.spacingSize.m} ${appTheme.spacingSize.l};
`;

export default StyledOcPopoverContent;
